import type { Location } from 'vue-router';
import type { IConnectionsStep } from './types';
import { OnboardingSuggestedProductPathKey } from './types';
import {
  ACADEMY_PAGE,
  JOBS_PAGE,
  PERFORMANCE_INDEX_PAGE,
  PORTFOLIO_PAGE,
  WAR_ROOM_PAGE,
  JOBS_PROFILE_PAGE,
} from '~/constants';

export const ONBOARDING_SUGGESTED_PRODUCT_PATHS: { [key in OnboardingSuggestedProductPathKey]: Location } = {
  [OnboardingSuggestedProductPathKey.PublicPortfolio]: PORTFOLIO_PAGE,
  [OnboardingSuggestedProductPathKey.PerformanceIndex]: PERFORMANCE_INDEX_PAGE,
  [OnboardingSuggestedProductPathKey.WarRoom]: WAR_ROOM_PAGE,
  [OnboardingSuggestedProductPathKey.Academy]: ACADEMY_PAGE,
  [OnboardingSuggestedProductPathKey.Jobs]: JOBS_PAGE,
  [OnboardingSuggestedProductPathKey.JobsProfile]: JOBS_PROFILE_PAGE,
};

export const CONNECTIONS_STEPS: IConnectionsStep[] = [
  {
    key: 'sync',
    title: 'Get endorsed by your network',
    description:
      'Member with 5+ endorsements get VIP benefits from hiring managers, prospects, and influencers on Bravado',
    component: 'ConnectionsSync',
    path: '/connections/sync',
  },
  {
    key: 'contacts',
    title: 'Connect with top Bravado Members',
    description:
      'Grow your network and give your colleagues VIP access to Bravado by choosing which you’d like to invite.',
    component: 'ConnectionsContacts',
    path: '/connections/contacts',
  },
];

export const CONNECTIONS_STEPS_MAP = Object.fromEntries(CONNECTIONS_STEPS.map(step => [step.key, step]));
export const GOOGLE_OAUTH_KEY = 'google_oauth2';
